import { ceil } from "lodash";

export function computePerPayPeriod (namedArgs: {
  totalAmount: number,
  numberOfPeriods: number
}) {
  const { totalAmount, numberOfPeriods } = namedArgs;
  return (numberOfPeriods < 1) ?
    0 :
    ceil(totalAmount / numberOfPeriods, 2);
}

export function computeEarlyPayDate (namedArgs: {
  amountLimit: number,
  perPayPeriodAmount: number,
  sortedPayDates: string[]
}) {
  const { amountLimit, perPayPeriodAmount, sortedPayDates } = namedArgs;
  if ((perPayPeriodAmount <= amountLimit) && ((perPayPeriodAmount * (sortedPayDates.length - 1) >= amountLimit))) {
    return sortedPayDates[ceil(amountLimit / perPayPeriodAmount) - 1];
  }
  return null;
}